import React from 'react';

const DashboardTile = ({ title, icon: Icon, onClick, colSpan = 2, rowSpan = 1, legend, className = '', children }) => {
  const style = {};
  if (colSpan !== 1) style.gridColumn = `span ${colSpan}`;
  if (rowSpan !== 1) style.gridRow = `span ${rowSpan}`;

  return (
    <div
      className={`stui-tile ${onClick ? 'stui-clickable' : ''} ${className}`}
      style={style}
      onClick={onClick}
    >
      {(Icon || title) && (
        <div className="stui-tile-header">
          {Icon && <Icon size={18} className="stui-tile-icon" />}
          {title && <span className="stui-tile-title">{title}</span>}
        </div>
      )}
      <div className="stui-tile-content">
        {children}
      </div>
      {legend && legend.length > 0 && (
        <div className="stui-tile-legend">
          {legend.map((item, i) => (
            <span key={i} className="stui-legend-item">
              <span className={`stui-legend-dot ${item.colorClass || ''}`} />
              {item.label}: {item.value}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default DashboardTile;
